import Button from "@material-ui/core/Button";
// import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import ArrowBack from "@material-ui/icons/ArrowBack";
import ArrowForward from "@material-ui/icons/ArrowForward";
import Assignment from "@material-ui/icons/Assignment";
import update from "immutability-helper";
import * as React from "react";
import { RouterProps } from "react-router";
import { Link } from "react-router-dom";
import {
  IProperPostResponse,
  IQuestionRequest,
  ISanitizedSurveyQuestion,
  ISurveyRespondentRequest,
  ISurveyRespondentResponse,
  ResponseSource,
  TemplateQuestionCategory,
  TemplateQuestionType,
} from "src/services";
import Component from "../../components/Component";
import MobilePage from "../../components/MobilePage";
import withAxios, { IAxiosProps } from "../../components/withAxios";
import {
  IFinishedSurveySection,
  IRespondentPagePassedDown,
} from "../RespondentPage";
import Question from "./surveyRespondPage/Question";
import { Box } from "@material-ui/core";
// import { hexToRGB } from "src/util";

const styles = (theme: Theme): Record<string, CSSProperties> => ({
  button: {
    padding: "8px 16px",
    textTransform: "none",
    boxShadow: "none",
    borderRadius: "8px",
    "@media (max-width: 768px)": {
      padding: "6px 10px 5px",
    },
  },
  buttonDiv: {
    marginTop: "8px",
    marginLeft: "-1rem",
    marginRight: "-1rem",
    padding: "22px",
    background: "rgba(253, 253, 253, 0.50)",
    border: "2px solid rgba(225, 229, 239, 0.50)",
    borderWidth: "2px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap",
    "@media (max-width: 768px)": {
      gap: "10px",
    },
  },
  buttonHint: {
    color: "#333333",
    fontFamily: '"Inter", sans-serif !important',
    fontSize: "14px",
    margin: 0,
    "@media (max-width: 768px)": {
      fontSize: "11px",
    },
  },
  buttonActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
    "@media (max-width: 768px)": {
      gap: "5px",
    },
  },
  categoryType: {
    fontSize: 26,
  },
  disclaimerText: {
    color: "#333",
    fontFamily: '"Inter", sans-serif !important',
    fontSize: "12px",
    fontWeight: 600,
    margin: 0,
  },
  disclaimerCard: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    backgroundColor: "#f8f8ff",
    border: "1px solid #e8e9fb",
    borderRadius: "10px",
    padding: "10px 12px",
    marginBottom: "14px",
  },
  disclaimerIcon: {
    color: "#8d92ff",
    fontSize: "15px",
    lineHeight: 1,
    marginTop: "2px",
  },
  disclaimerTitle: {
    color: "#4c57c5",
    fontSize: "12px",
    fontWeight: 700,
    marginBottom: "2px",
  },
  heading: {
    color: "#686868",
    fontSize: "20px",
    marginBottom: "2rem",
  },
  questionWrapper: {
    backgroundColor: "transparent",
    borderRadius: "0",
    border: "none",
    padding: "0",
  },
  plainButtonLabel: {
    "& .MuiButton-label": {
      fontFamily: '"Inter", sans-serif !important',
      fontStyle: "normal",
      color: "#FFF",
      fontSize: "14px",
      fontWeight: 700,
      lineHeight: 1.2,
      "@media (max-width: 768px)": {
        fontSize: "12px",
      },
      "&::before": {
        content: '""',
      },
      "&::after": {
        content: '""',
      },
    },
    "& .MuiSvgIcon-root": {
      color: "#FFF",
    },
  },
  nextButton: {
    backgroundColor: "#000000 !important",
    color: "#ffffff !important",
    "&:hover": {
      backgroundColor: "#000000 !important",
    },
    "&.Mui-disabled": {
      backgroundColor: "#9ba3b5 !important",
      color: "#ffffff !important",
    },
  },
});

interface ISurveyRespondPageProps {
  code: string;
  coachId: number | undefined;
  category: number;
  collectRespondentName: boolean;
  section: number;
  finishedSurveySectionPush: (
    finishedSurveySection: IFinishedSurveySection
  ) => void;
  respondentName: string;
  forVideoMidSeson: boolean;
   schoolData:any;
}

type IProps = ISurveyRespondPageProps &
  IRespondentPagePassedDown &
  RouterProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface ISurveyRespondPageState {
  questionResponses: IQuestionRequest[]; // It is a request to the server that is why it is named like this
  respondentName: string;
  submitting?: true;
}

const QUESTION_SPLIT_MIN = 6;

const getSeasonLabelFromStartDate = (startDate?: number): string => {
  if (typeof startDate !== "number" || Number.isNaN(startDate)) {
    return "Fall";
  }

  const month = new Date(startDate).getMonth();
  if (month >= 7 && month <= 10) {
    return "Fall";
  }
  if (month === 11 || month <= 1) {
    return "Winter";
  }
  return "Spring";
};

export default withStyles(styles)(
  withAxios(
    class SurveyRespondPage extends Component<IProps, ISurveyRespondPageState> {
      public constructor(props: IProps) {
        super(props);
        this.state = {
          questionResponses: ((): IQuestionRequest[] => {
            if (props.surveyResponse !== undefined) {
              return this.convertQuestions(props.surveyResponse.questions);
            } else {
              return [];
            }
          })(),
          respondentName: "",
        };
      }

      public componentDidMount() {
        const {
          collectRespondentName,
          loadSurvey,
          code,
          history,
          category,
          coachId,
          responseSource,
          respondentName,
          section,
        } = this.props;
        loadSurvey(code);

        // If respondentName is missing after a refresh, return to coach select
        // where the respondent name is now collected.
        if (collectRespondentName && respondentName === "") {
          history.push(`/${ResponseSource[responseSource]}/${code}`);
          return;
        }
        // If user refreshes at end of page bring them back
        // console.log(category, this.getCategoryLength());
        else if (category === this.getCategoryLength()) {
          // bring user back to coach select page
          history.push(`/${ResponseSource[responseSource]}/${code}`);
        } else if (category !== 0 || section !== 0) {
          // bring user back to start of survey
          history.push(
            `/${ResponseSource[responseSource]}/${code}/${coachId}/${0}`
          );
        }
      }

      public componentDidUpdate(prevProps: IProps) {
        const {
          surveyResponse,
          responseSource,
          history,
          coachId,
          code,
          finishedSurveySections,
          category,
        } = this.props;

        // if there are no questions in the current category, skip ahead to the next category.
        if (
          surveyResponse !== undefined &&
          surveyResponse.questions.find(
            (question) => question.category === category
          ) === undefined
        ) {
          if (category < this.getCategoryLength()) {
            history.push(
              `/${ResponseSource[responseSource]}/${code}/${coachId}/${
                category + 1
              }`
            );
          }
        }
        // make the user return to the coach select if the coach page they are at
        // is already marked as done.
        if (
          finishedSurveySections.find(
            (fS) =>
              fS.code === code &&
              fS.coachId === coachId &&
              category < this.getCategoryLength()
          )
        ) {
          history.push(`/${ResponseSource[responseSource]}/${code}`);
        }

        // check if a coach is in the coachs list. If not then send the user back
        if (
          surveyResponse !== undefined &&
          !surveyResponse.coaches.find((c) => c.id === coachId)
        ) {
          history.push(`/${ResponseSource[responseSource]}/${code}`);
        }

        this.setNewQuestionsState(prevProps);
      }

      // render for both students and coaches
      public render() {
        const {
          responseSource,
          surveyResponse,
          loadingSurvey,
          category,
          coachId,
          school,
          // classes,
          forVideoMidSeson
        } = this.props;
        if (surveyResponse === undefined) {
          if (loadingSurvey) {
            return <LinearProgress variant="query" />;
          }
          return <h1>Oops... something went wrong. Survey not loaded.</h1>;
        }
        const coach = surveyResponse.coaches.find((c) => c.id === coachId);
        const progressTotal = surveyResponse.questions.length;
        const progressCurrent = this.state.questionResponses
          ? this.state.questionResponses.filter(
              (questionResponse) =>
                questionResponse &&
                questionResponse.response &&
                questionResponse.response !== ""
            ).length
          : 0;
        if (coach === undefined) {
          return <h1>Oops... something went wrong. {this.props.schoolData.isAdSurvey ? "AD" : "Coach"} was not found.</h1>;
        }
        const isAdSurvey =
          this.props.schoolData?.isAdSurvey === true || school.isAdSurvey === true;

        const sportName = (() => {
          if (
            surveyResponse === undefined ||
            surveyResponse.sport === undefined
          ) {
            return ``;
          } else {
            return `${this.props?.schoolData?.isEmbeddable === true ? "" : ":"+ surveyResponse.sport.name}`;
          }
        })();

        const firstToUpper = (s: string): string =>
          s === undefined ? "" : s[0].toUpperCase() + s.substring(1);

        const unfinishedSurvey = category < this.getCategoryLength();
        const respondentTypeLabel = (() => {
          switch (responseSource) {
            case ResponseSource.student:
              return isAdSurvey ? "Coach" : "Student";
            case ResponseSource.parent:
              return "Parent";
            case ResponseSource.coach:
              return isAdSurvey ? "AD" : "Coach";
            default:
              return "";
          }
        })();

        const headline = (() => {
          const headlineVar = unfinishedSurvey
            ? `${firstToUpper(TemplateQuestionCategory[category])}`
            : respondentTypeLabel;
          return headlineVar !== "Written Response"
            ? headlineVar
            : "Written Comments";
        })();

        const survey = unfinishedSurvey
          ? this.renderSurveyCategory()
          : this.renderFinishedPage(surveyResponse);
        const seasonLabel = getSeasonLabelFromStartDate(surveyResponse.survey?.startDate);
        switch (responseSource) {
          case ResponseSource.student:
            return (
              <MobilePage
                header={sportName}
                title={`${this.props.schoolData.isAdSurvey ? "AD:" :"Coach:"} ${coach.name}`}
                subtitle=""
                schoolLogo={school.logo1}
                schoolLogo2={school.logo2}
                schoolName={school.name}
                headerIcon={<Assignment />}
                tagline={`${school.tagline}`}
                headLine= {headline}
                type="Student"
                forVideoMidSeson={forVideoMidSeson}
                showSurveyHeader={true}
                tightSurveyHeader={true}
                coachName={coach.name}
                sportName={surveyResponse.sport?.name || ''}
                seasonName={seasonLabel}
                progressCurrent={progressCurrent}
                progressTotal={progressTotal}
              >
                {/* Removed category heading as requested */}
                {survey}
              </MobilePage>
            );
          case ResponseSource.coach:
            return (
              <MobilePage
                header={sportName}
                title={`${this.props.schoolData.isAdSurvey ? "AD" : "Coach"
}: ${coach.name}`}
                subtitle="Self-survey is imperative for great leaders."
                schoolLogo={school.logo1}
                schoolLogo2={school.logo2}
                schoolName={school.name}
                headerIcon={<Assignment />}
                tagline={`${school.tagline}`}
                headLine= {headline}
                type= "Coach"
                showSurveyHeader={true}
                tightSurveyHeader={true}
                coachName={coach.name}
                sportName={surveyResponse.sport?.name || ''}
                seasonName={seasonLabel}
                progressCurrent={progressCurrent}
                progressTotal={progressTotal}
              >
                {/* Removed category heading as requested */}
                {survey}
              </MobilePage>
            );
          case ResponseSource.parent:
            return (
              <MobilePage
                header={sportName}
                title={`${this.props.schoolData.isAdSurvey ? "AD:" :"Coach:"} ${coach.name}`}
                subtitle=""
                schoolLogo={school.logo1}
                schoolLogo2={school.logo2}
                schoolName={school.name}
                headerIcon={<Assignment />}
                tagline={`${school.tagline}`}
                headLine= {headline}
                type= "Parent"
                showSurveyHeader={true}
                tightSurveyHeader={true}
                coachName={coach.name}
                sportName={surveyResponse.sport?.name || ''}
                seasonName={seasonLabel}
                progressCurrent={progressCurrent}
                progressTotal={progressTotal}
              >
                {/* Removed category heading as requested */}
                {survey}
              </MobilePage>
            );
          default:
            return <span>Something is wrong</span>;
        }
      }

      private renderFinishedPage(surveyResponse: ISurveyRespondentResponse) {
        const { responseSource, code, finishedSurveySections, coachId } =
          this.props;
        const coach = surveyResponse.coaches.find((c) => c.id === coachId);
        if (coach === undefined) {
          return <span>Oops {this.props.schoolData.isAdSurvey ? "AD" : "coach"} not found</span>;
        }
        const finished =
          surveyResponse.coaches.filter(
            (c) =>
              !finishedSurveySections.find(
                (fS) => fS.coachId === c.id && fS.code === code
              )
          ).length === 0;
        return (
          <div className="survey-finished-message">
            <br />
            {(() => {
              if (
                !finished &&
                (responseSource === ResponseSource.student ||
                  responseSource === ResponseSource.parent)
              ) {
                return (
                  <div>
                    <span>
                      Success! You have completed your survey about {this.props.schoolData.isAdSurvey ? "AD" : "Coach"}{" "}
                      {coach.name}. <br />
                      <span style={{ padding: "0px 2px 0px 2px" }}>
                        <Button
                          color="primary"
                          component={Link}
                          {...({
                            to:`/${ResponseSource[responseSource]}/${code}`,
                          } as any)}
                        >
                          Start New {this.props.schoolData.isAdSurvey ? "AD" : "Coach"} Survey
                        </Button>
                      </span>
                    </span>
                  </div>
                );
              }
              switch (responseSource) {
                case ResponseSource.student:
                  return (
                    <span>
                      Success! You have completed your survey about {this.props.schoolData.isAdSurvey ? "AD" : "Coach"}{" "}
                      {coach.name}.
                    </span>
                  );
                case ResponseSource.coach:
                  return (
                    <span>Thanks {this.props.schoolData.isAdSurvey ? "AD" : "Coach"}! Your answers have been recorded.</span>
                  );
                case ResponseSource.parent:
                  return <span>Thanks! Your answers have been recorded.</span>;
                default:
                  return <span>Oops... something went wrong</span>;
              }
            })()}
          </div>
        );
      }

      private renderSurveyCategory() {
        const {
          surveyResponse,
          loadingSurvey,
          category,
          classes,
          responseSource,
          school,
        } = this.props;
        const { submitting } = this.state;
        if (
          surveyResponse === undefined ||
          surveyResponse.survey === undefined
        ) {
          if (loadingSurvey) {
            return <LinearProgress variant="query" />;
          }
          return <h1>Oops... something went wrong</h1>;
        }

        const isAdSurvey =
          this.props.schoolData?.isAdSurvey === true || school.isAdSurvey === true;
        const adSurveyDisclaimer =
          "Your Athletic Director will see your responses, so please answer honestly and thoughtfully. Great leaders seek feedback because they want to improve, and your honest input will help our athletic department better serve coaches, students, and families while building a stronger athletic community for everyone to enjoy.";

        const disclaimerText = (() => {
          switch (category) {
            case TemplateQuestionCategory.expectations:
              return "";
            case TemplateQuestionCategory.warmth:
              return "";
            case TemplateQuestionCategory.other:
              if (isAdSurvey) {
                return adSurveyDisclaimer;
              }
              // different message for coaches vs students/parents
              if (responseSource === ResponseSource.coach) {
                return "Your comments will be used to shape the conversation toward the best course of action for your growth and development as a leader.";
              }
              return "We promise to keep your specific remarks confidential. Your comments will not be shared with your coach.";
            case TemplateQuestionCategory.parent:
              return "";
            default:
              return "";
          }
        })();

        // only render the questions of the category
        return (
          <Box>
            {Boolean(disclaimerText) && (
              <Box className={classes.disclaimerCard}>
                {/* <span className={classes.disclaimerIcon}>🔒</span> */}
                <Box>
                  {/*
                  <Typography className={classes.disclaimerTitle}>
                    {responseSource === ResponseSource.coach
                      ? "Written responses matter."
                      : "Confidentiality is important to us."}
                  </Typography>
                  */}
                  <Typography className={classes.disclaimerText}>
                    {disclaimerText}
                  </Typography>
                </Box>
              </Box>
            )}
            {this.renderQuestions(category, surveyResponse.questions)}
            {submitting && <LinearProgress />}
            <Box className={classes.buttonDiv}>
              <Typography className={classes.buttonHint}>
                {category === TemplateQuestionCategory.other
                  ? "Complete all responses to finish"
                  : "Answer all questions to continue"}
              </Typography>
              <Box className={classes.buttonActions}>
                {this.renderBackButton(category)}
                {this.renderButton(category, surveyResponse.questions)}
              </Box>
            </Box>
          </Box>
        );
      }

      private renderBackButton(category: number) {
        const { responseSource, code, coachId, surveyResponse, classes } = this.props;
        const previousPath = this.getPreviousPagePath(category);

        if (!surveyResponse) {
          return null;
        }

        const goBacklink =
          previousPath === null
            ? `/${ResponseSource[responseSource]}/${code}`
            : `/${ResponseSource[responseSource]}/${code}/${coachId}/${previousPath}`;

        if (!!surveyResponse) {
          return (
            <Button
              variant="contained"
              color="default"
              component={Link}
              to={goBacklink}
              className={`${classes.button} ${classes.plainButtonLabel} back-hover`}
            >
              <ArrowBack style={{ fontSize: 14, marginRight: 6 }} />
              Back
            </Button>
          );
        }
        return null;
      }

      // questionsCategoryIndex: -1 if question not in expectations, warmth, other, or parent. otherwise the number of the categoryIndex
      private getValidQuestions(inputCategory?: number) {
        const { surveyResponse, section, category: cat } = this.props;
        const category = inputCategory !== undefined ? inputCategory : cat;
        if (surveyResponse === undefined) {
          return {
            questionsCategoryIndex: [],
            splitSection: false,
          };
        }
        const categoryQuestionLength = surveyResponse.questions.filter(
          (q) => q.category === category
        ).length;
        // only split section if enough questions
        const splitSection = categoryQuestionLength >= QUESTION_SPLIT_MIN;

        const categoryStartIndexes = [0, 1, 2, 3].map((index) =>
          surveyResponse.questions.findIndex((q) => q.category === index)
        );

        const questionsCategoryIndex = surveyResponse.questions.map((q, i) => {
          const categoryIndex = i - categoryStartIndexes[q.category];
          const categorySectionFirst =
            categoryIndex >= Math.ceil(categoryQuestionLength / 2);
          if (
            q.category === category &&
            !(
              splitSection &&
              ((section === 0 && categorySectionFirst) ||
                (section === 1 && !categorySectionFirst))
            )
          ) {
            return categoryIndex;
          } else {
            return -1;
          }
        });
        return {
          questionsCategoryIndex,
          splitSection,
        };
      }

      private renderQuestions(
        category: number,
        questions: ISanitizedSurveyQuestion[]
      ) {     
        const { classes } = this.props;
        const entryLevel = this.props.surveyResponse?.survey?.entryLevel;
        const hideWrittenResponseGuidance =
          entryLevel !== undefined && entryLevel >= 1 && entryLevel <= 4;
        const { questionResponses } = this.state;
        const { questionsCategoryIndex } = this.getValidQuestions(
          this.props.category
        );
        return (
          <Box display="flex" flexDirection="column" gridGap="0.75rem">
            {questions.map((q, i) => {
              if (questionsCategoryIndex[i] === -1) {
                return null;
              }
              return (
                <Box key={q.id} className={classes.questionWrapper}>
                  <Question
                    questionResponse={questionResponses[i]}
                    question={q}
                    index={i}
                    isAdSurvey={
                      this.props.schoolData?.isAdSurvey === true ||
                      this.props.school.isAdSurvey === true
                    }
                    hideWrittenResponseGuidance={hideWrittenResponseGuidance}
                    categoryIndex={
                      !isNaN(questionsCategoryIndex[i])
                        ? questionsCategoryIndex[i]
                        : -1
                    }
                    handleResponseChange={this.handleResponseChange}
                  />
                </Box>
              );
            })}
          </Box>
        );
      }

      private handleResponseChange =
        (i: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
          // set value here to make it turn to a value instead of pointer
          const value = e.target.value;
          this.setState((prevState) =>
            update(prevState, {
              questionResponses: {
                [i]: { response: { $set: value } },
              },
            })
          );
        };

      private getCategoryLength = () => {
        return Object.keys(TemplateQuestionCategory).length / 2;
      };

      private getPreviousPagePath = (category: number): string | null => {
        const { surveyResponse, section } = this.props;

        if (surveyResponse === undefined) {
          return null;
        }

        if (section === 1) {
          return `${category}`;
        }

        for (
          let previousCategory = category - 1;
          previousCategory >= 0;
          previousCategory--
        ) {
          const questionCount = surveyResponse.questions.filter(
            (question) => question.category === previousCategory
          ).length;

          if (questionCount === 0) {
            continue;
          }

          const { splitSection } = this.getValidQuestions(previousCategory);
          return splitSection
            ? `${previousCategory}/1`
            : `${previousCategory}`;
        }

        return null;
      };

      private disableButton = (): boolean => {
        const {
          // category,
          surveyResponse,
        } = this.props;
        const { questionResponses } = this.state;
        // disable button if the questions are not answered
        // add these variables to easily change what type of questions must be answered
        const ALLSCALE = true;
        const ALLWRITTEN = true;
        if (surveyResponse === undefined) {
          return false;
        }
        // filter questions responses that are in the category and section
        const { questionsCategoryIndex } = this.getValidQuestions();
        const categoryAndSectionQuestions = questionResponses.filter(
          (qR, i) => questionsCategoryIndex[i] !== -1
        );
        const scaleQuestions = categoryAndSectionQuestions.filter(
          (cQ) => cQ.type === TemplateQuestionType.scale
        );
        const writtenQuestions = categoryAndSectionQuestions.filter(
          (cQ) => cQ.type === TemplateQuestionType.written
        );
        const allScaleQuestionsAnswered = !Boolean(
          scaleQuestions.find((qR) => qR.response === "")
        );
        const allWrittenQuestionsAnswered = !Boolean(
          writtenQuestions.find((qR) => qR.response === "")
        );
        // console.log('scale', allScaleQuestionsAnswered, 'question', allWrittenQuestionsAnswered);
        if (ALLSCALE && ALLWRITTEN) {
          return !(allScaleQuestionsAnswered && allWrittenQuestionsAnswered);
        }
        if (ALLWRITTEN) {
          return !allWrittenQuestionsAnswered;
        }
        return !allScaleQuestionsAnswered;
      };

      private renderButton(
        category: number,
        questions: ISanitizedSurveyQuestion[]
      ) {
        const { responseSource, code, coachId, classes, section } = this.props;
        const { submitting } = this.state;
        const { questionsCategoryIndex, splitSection } =
          this.getValidQuestions();
        const moreQuestions =
          questionsCategoryIndex[questionsCategoryIndex.length - 1] === -1;
        const linkEnd = () => {
          if (splitSection && section === 0) {
            return `${category}/1`;
          }
          return `${category + 1}`;
        };
        if (!moreQuestions) {
          return (
            <Button
              disabled={Boolean(submitting)}
              color="primary"
              variant="contained"
              onClick={this.finishSurvey}
              className={`${classes.button} ${classes.plainButtonLabel} ${classes.nextButton}`}
            >
              Finish
            </Button>
          );
        } else {
          return (
            <Button
              disabled={this.disableButton()}
              color="primary"
              variant="contained"
              component={Link}
              onClick={this.nextButtonClick}
              {...({
                to: `/${
                  ResponseSource[responseSource]
                }/${code}/${coachId}/${linkEnd()}`,
              } as any)}
              className={`${classes.button} ${classes.plainButtonLabel} ${classes.nextButton}`}
            >
              Next
              <ArrowForward style={{ fontSize: 14, marginLeft: 6 }} />
            </Button>
          );
        }
      }

      private nextButtonClick = () => {
        window.scroll(0, 0);
      };

      private setNewQuestionsState = (prevProps: IProps) => {
        const { surveyResponse } = this.props;
        // make sure things are not undefined for the next code
        if (
          surveyResponse === undefined ||
          surveyResponse.survey === undefined ||
          !surveyResponse.properAccess
        ) {
          // should not set the new data
          return;
        }

        if (
          this.state.questionResponses.length === 0 ||
          prevProps.surveyResponse === undefined ||
          prevProps.surveyResponse.survey === undefined ||
          surveyResponse.survey.code !== prevProps.surveyResponse.survey.code
        ) {
          this.setState({
            questionResponses: this.convertQuestions(surveyResponse.questions),
            respondentName: "",
          });
        }
      };

      // converts the question to the response parts.
      // because the questions are ordered properly it should be easy to
      private convertQuestions = (
        questionResponse: ISanitizedSurveyQuestion[]
      ): IQuestionRequest[] => {
        const { coachId } = this.props;
        if (coachId === undefined) {
          return [];
        }
        return questionResponse.map((qR) => ({
          response: "",
          surveyQuestionId: qR.id,
          type: qR.type,
        }));
      };

      private allWrittenResponsesAnswered = (): boolean =>
        !Boolean(
          this.state.questionResponses.find(
            (qR) =>
              qR.type === TemplateQuestionType.written &&
              String(qR.response || "").trim() === ""
          )
        );

      private finishSurvey: () => undefined = () => {
        if (!this.allWrittenResponsesAnswered()) {
          window.alert(
            "You have not responded to all questions. Please ensure all the questions are completed before submitting the survey."
          );
          return undefined;
        }

        void this.runCancellableStatefulAsync(
          this,
          {
            submitting: true,
          },
          {
            submitting: undefined,
          },
          async () => {
            const { questionResponses } = this.state;
            const {
              surveyResponse,
              responseSource,
              coachId,
              history,
              finishedSurveySectionPush,
              respondentName,
            } = this.props;
            if (
              surveyResponse === undefined ||
              surveyResponse.survey === undefined
            ) {
              return;
            }
            const code = surveyResponse.survey.code;
            if (coachId === undefined) {
              return;
            }
            const properAccess = await this.buildPost<
              ISurveyRespondentRequest,
              IProperPostResponse
            >(
              this,
              `survey/respond/${responseSource}/${code}/${coachId}`
            )({
              questionResponses,
              respondentName,
            });
            if (properAccess.properAccessCode && properAccess.properDataSent) {
              history.push(
                `/${
                  ResponseSource[responseSource]
                }/${code}/${coachId}/${this.getCategoryLength()}`
              );
              this.nextButtonClick();
              if (properAccess.finishedSurveySection) {
                finishedSurveySectionPush({ coachId, code });
              }
              // do something about this
              // history.push(`/${ResponseSource[responseSource]}/${code}`);
            } else {
              window.alert(properAccess.errorMessage);
            }
          },
          () => {
            this.setState({ submitting: undefined });
          }
        );
        return undefined;
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/respondent/SurveyRespondPage.tsx